import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import RadioButton from "./radio-button";

var radioButtonComponentPropType = function radioButtonComponentPropType(propValue, key, componentName, location, propFullName) {
  if (propValue[key].type !== RadioButton) throw new Error("Invalid prop '".concat(propFullName, "' supplied to '").concat(componentName, "' Validation failed."));
};

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var children = _ref.children,
      id = _ref.id,
      className = _ref.className;
  return React.createElement("div", {
    className: cx('RadioButtonGroup', className),
    id: id
  }, children);
};

RadioButtonGroup.displayName = 'RadioButtonGroup';
RadioButtonGroup.propTypes = {
  children: PropTypes.arrayOf(radioButtonComponentPropType).isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string
};
export default RadioButtonGroup;